import { lazy } from 'react';

const AdminReportsAboutAdvertisers = lazy(() => import('./admin-reports-about-advertisers'));;
const AdminReportsAboutBranches = lazy(() => import('./admin-reports-about-branches'));;
const AdminReportsAboutCategories = lazy(() => import('./admin-reports-about-categories'));;
const AdminReportsAboutReservations = lazy(() => import('./admin-reports-about-reservations'));;
const AdminReportsAboutSales = lazy(() => import('./admin-reports-about-sales'));;
const AdminReportsAboutMeraki = lazy(() => import('./admin-reports-about-meraki'));;
const AdminReportsDemographics = lazy(() => import('./admin-reports-demographics'));;
const AdminReportsTraffic = lazy(() => import('./admin-reports-traffic'));;
const AdminReportsVisitFrequency = lazy(() => import('./admin-reports-visit-frequency'));;
const AdminReportsStayTime = lazy(() => import('./admin-reports-stay-time'));;
const AdminProductLoads = lazy(() => import('./admin-product-loads'));;


export default {
  AdminReportsAboutAdvertisers,
  AdminReportsAboutBranches,
  AdminReportsAboutCategories,
  AdminReportsAboutReservations,
  AdminReportsAboutSales,
  AdminReportsAboutMeraki,
  AdminReportsDemographics,
  AdminReportsTraffic,
  AdminReportsVisitFrequency,
  AdminReportsStayTime,
  AdminProductLoads
};
